module.exports = __webpack_public_path__ + "img/icon-wall.a7373b88.svg";